import { SearchResult } from "../components/TradeInModal/DeviceSearch/types";

export type SearchResponse = {
  status: number;
  error?: string;
  searchDevices?: SearchResult;
};
export const searchDevices = async (
  tradeInUrl: string,
  query: string,
  abortController: AbortController,
): Promise<SearchResponse> => {
  const queryString = "?q=" + encodeURIComponent(query);
  const url = tradeInUrl + "/devices" + queryString;
  return await fetch(url, {
    signal: abortController?.signal,
    method: "GET",
    credentials: "omit",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async function (response: Response) {
      const { status } = await response;
      if (response.ok && status == 200) {
        return { status, searchDevices: await response.json() };
      }
      return { status: status, error: "Trade in search device failed" };
    })
    .catch(() => {
      return { status: 400, error: "Trade in search device failed" };
    });
};
